


<template>
    <div class="md-layout-item md-medium-size-100 md-xlarge-size-50">
        <h3>Contact Details</h3>
        <p class="margin_bottom">Essential contact information</p>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Website
            </label>
            <div class="md-layout-item md-size-40">
                <ValidationProvider name="Website"
                                    :rules="{ required:true, min:5, max:2084, regex: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i}" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input v-model="contact.website" placeholder="e.g. http://clientcompany.com" autocomplete="new-website"></md-input>
                        <span class="md-helper-text">Public on websites (e.g. http://clientcompany.com)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label">
                Contact Link
            </label>
            <div class="md-layout-item md-size-50">
                <ValidationProvider name="Contact Link" :rules="{ min:5, max:2084, regex: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i}" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input v-model="contact.contactWebsite" placeholder="e.g. http://clientcompany.com/contact-us" autocomplete="new-contact-website"></md-input>
                        <span class="md-helper-text">Optional (link to contact form for tenant websites)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <contact-editor :contactId="contact.primaryContactId"
                        :contacts="contacts"
                        :isStaff="isStaff"
                        :facilitiesManagers="fms"
                        :portfolios="portfolios"
                        v-on:changeId="contact.primaryContactId = $event"
                        v-on:refreshList="refreshContacts"
                        label="Primary Contact"
                        :isDisabled="loading">
        </contact-editor>

    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min, max, email } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("email", email);

    import { ContactTypes } from '@/ts/ContactComponents';
    import Api from '@/ts/UvApiService';
        import ContactEditor from '@/components/Contact/Editor.vue';

    export default {
        name: "CompanyContact",
        components: {
            SlideYDownTransition
            , ContactEditor
        },
        props: {
            contact: {
                website: null,
                contactWebsite: null,
                primaryContactId: null,
            },
            organisationId: null,
            contactType: null,
        },
        data() {
            return {
                loading: true,
                contacts: [],
            }
        },
        computed: {
            isStaff() {
                return this.contactType === ContactTypes.Staff;
            },
            fms() {
                if (this.contactType === ContactTypes.facilitiesManagement)
                    return [this.organisationId];
                return [];
            },
            portfolios() {
                if (this.contactType === ContactTypes.portfolio)
                    return [this.organisationId];
                return [];
            }
        },
        methods: {
            async refreshContacts() {
                if (this.isStaff) {
                    this.contacts = await Api.contacts.getAllSimpleInternal();
                }
                else if (this.contactType === ContactTypes.facilitiesManagement) {
                    this.contacts = await Api.contacts.getAllSimpleFM(this.organisationId);
                }
                else if (this.contactType === ContactTypes.portfolio) {
                    this.contacts = await Api.contacts.getAllSimplePortfolio(this.organisationId);
                }
            },
        },
        async created() {
            await this.refreshContacts();
            this.loading = false;
        },
    };
</script>
